module.exports = __webpack_public_path__ + "static/media/photoshop-logo-cropped.f9318bb8.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/photoshop-logo-cropped.png
// module id = 69
// module chunks = 0